import React, { FC } from 'react'
import { makeStyles } from 'transfix-ui/core'
import { IAs2ConnectionConfigConnection } from 'types/graphqlTypes'
import { brandColors, Table, TableBody, TableCell, TableHead, TableRow } from 'transfix-ui'
import { AS2ConnectionConfigTableRow } from './AS2ConnectionConfigsTableRow'
import { IAs2ConnectionConfigSchema } from './schema/AS2ConnectionConfigSchema'

interface IAS2ConnectionConfigTableProps {
  as2ConnectionConfigs: IAs2ConnectionConfigConnection
  onEdit: (options: IAs2ConnectionConfigSchema) => void
}

const useAS2ConnectionConfigTableStyles = makeStyles(theme => ({
  root: {
    background: 'transparent',
    marginTop: theme.spacing(1),
    '& thead': {
      background: 'transparent',
    },
    '& th:first-child, td:first-child': {
      paddingLeft: 0,
    },
    '& td': {
      borderBottom: `1px solid ${brandColors.coolGray3}`,
    },
  },
}))

export const AS2ConnectionConfigTable: FC<IAS2ConnectionConfigTableProps> = ({
  as2ConnectionConfigs,
  onEdit,
}) => {
  const classes = useAS2ConnectionConfigTableStyles()

  if (!as2ConnectionConfigs) {
    return null
  }

  const { nodes } = as2ConnectionConfigs

  return (
    <Table className={classes.root}>
      <TableHead>
        <TableRow tableCellType='th'>
          <TableCell>ID</TableCell>
          <TableCell>Identifier</TableCell>
          <TableCell>Outbound URL</TableCell>
          <TableCell>Server Info Credentials Identifier</TableCell>
          <TableCell>Transfix Identifier</TableCell>
          <TableCell>Certificate Expiry</TableCell>
          <TableCell>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {nodes && nodes.length > 0 ? (
          nodes.map(as2ConnectionConfig => (
            <AS2ConnectionConfigTableRow
              key={as2ConnectionConfig?.id}
              as2ConnectionConfig={as2ConnectionConfig!}
              onEdit={onEdit}
            />
          ))
        ) : (
          <TableRow>
            <TableCell className='tc' colSpan={4}>
              No configurations found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  )
}
